import axiosInterceptor from './axiosInterceptor';

const API_URL = process.env.REACT_APP_API_URL;

export const updateWorkOrder = (company, work_order_number, data, work_order) => {
    const body = {
        authorized_by: work_order.VHAUTH,
        bill_to_type: (!!data.bill_to_type) ? data.bill_to_type : work_order.VHBCOL,
        cause: data.cause,
        claim_type: "N",
        comm_points: 0,
        concern: data.concern,
        copies: 0,
        correction: data.correction,
        customer_number: (work_order[`VHCUS#`] == 0) ? "" : String(work_order[`VHCUS#`]),
        customer_rep: (work_order.VHSREP == 0) ? "" : String(work_order.VHSREP),
        department: work_order.VHDEPT,
        driver_lic_number: work_order[`VHDL#`],
        driver_lic_state: work_order.VHDLST,
        est_close_date: String(work_order.VHDATE),
        est_date_closed: String(work_order.VHDATE),
        expense_code: (!!data.expense_code) ? data.expense_code : work_order.VHCODE,
        head_mech: data.mechanic_id,
        job_bill_location: work_order.VHBLOC,
        job_location_desc: work_order.VHJOBL,
        labor_code: (!!data.labor_code) ? data.labor_code : work_order.labor_code,
        location: String(data.location),
        major_repair: work_order.VHMAJR,
        opened_date: String(work_order.VHDATE),
        phone_number: (work_order.VHPHON == 0) ? "" : work_order.VHPHON,
        po_number: work_order[`VHPO#`],
        print: "N",
        put_into_shop: data.put_into_shop,
        repair_ticket: (work_order.VHRTIX == 0) ? "" : String(work_order.VHRTIX),
        service_call: data.service_call,
        tax_number: work_order[`VHTAX#`],
        taxes: "",
        traxx_config_type: data.traxx_config_type,
        workorder_description: work_order.VHDESC
    }

    return (dispatch) => {
        return axiosInterceptor.put(`${API_URL}/workorder/${company}/${work_order_number}`, body)
                .then(response => response.data);
    }
}

export const getCommentExists = (company, id, type) => {
    const body = {
        params: {}
    }

    return (dispatch) => {
        return axiosInterceptor.get(`${API_URL}/comment/${company}/${id}`,body)
                .then(response => {
                    let data = response.data.comments.filter(c => c.comment_type);
                    if(data.length == 0)
                        return {
                            exists: false,
                            concern: ""
                        }
                    else
                        return {
                            exists: true,
                            concern: data[0].comment
                        }
                })
    }
}

export const getConfig = (company) => {
    const body = {
        params: {}
    }

    return (dispatch) => {
        return axiosInterceptor.get(`${API_URL}/config/${company}`,body)
                .then(response => response.data)
    }
}

export const updateDisposition = (company, work_order_number, set_disposition) => {
    const body = {
        set_disposition,
        loader: false
    }

    return (dispatch) => {
        return axiosInterceptor.put(`${API_URL}/workorder/disposition/${company}/${work_order_number}`, body)
                .then(response => response.data);
    }
}

export const startProgress = (message) => {
    return {
        type: "START_PROGRESS",
        payload: {
            message
        }
    }
}

export const updateProgress = (progress) => {
    return {
        type: "UPDATE_PROGRESS",
        payload: {
            progress
        }
    }
}

export const endProgress = (message, history, route) => {
    return {
        type: "END_PROGRESS",
        payload: {
            message,
            history,
            route
        }
    }
}

export function checkUnderWarranty(company, date) {
    let curDate = new Date();
    let exp_date = String(date);
    let expDate = new Date(`${exp_date.substring(0,4)}-${exp_date.substring(4,6)}-${exp_date.substring(6,8)}`);
    return curDate.getTime() <= expDate.getTime();
}

export function formatDate(date, time = "") {
    if(date != 0 && date !="") {
        let d = String(date);
        let t = String(time);
        if(t.length != 0) {
            let padT = t.padStart(6,"0");
            t = `${padT.substring(0,2)}:${padT.substring(2,4)}`;
        }
        return `${d.substring(4,6)}/${d.substring(6,8)}/${d.substring(2,4)} ${t}`;
    }
    else
        return "";
}

export function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        return negativeSign + "$" +(j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
        console.log(e)
    }
}

export function getDispositionColor(disposition) {
    let color = "";
    switch(disposition) {
        case "NI":
            color = "#F2711C";
            break;

        case "WS":
            color = "#FBBD08";
            break;

        case "MA":
            color = "#2185D0";
            break;

        case "IP":
            color = "#21BA45";
            break;

        case "WP":
            color = "#FB2408";
            break;

        case "OS":
            color = "#7808FB";
            break;
    }

    return color;
}

export function scrollTo(element, to, duration) {
    var start = element.scrollTop,
        change = to - start,
        currentTime = 0,
        increment = 20;
        
    var animateScroll = function(){        
        currentTime += increment;
        var val = Math.easeInOutQuad(currentTime, start, change, duration);
        element.scrollTop = val;
        if(currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };
    animateScroll();
}

//t = current time
//b = start value
//c = change in value
//d = duration
Math.easeInOutQuad = function (t, b, c, d) {
  t /= d/2;
	if (t < 1) return c/2*t*t + b;
	t--;
	return -c/2 * (t*(t-2) - 1) + b;
};

export const startTime = (company, location, id, data) => {
    const body = {
        ...data,
        loader: false
    }

    return (dispatch) => {
        return axiosInterceptor.post(`${API_URL}/time/${company}/${location}/${id}`, body)
                .then(response => response.data);
    }
}

export const stopTime = (company, location, id, data) => {
    const body = {
        ...data,
        loader: false
    }

    return (dispatch) => {
        return axiosInterceptor.put(`${API_URL}/time/${company}/${location}/${id}`, body)
                .then(response => response.data);
    }
}

export const loader = (loader) => {
    return {
        type: "LOADER",
        payload: {
            loader
        }
    }
}